// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b6-3";
export var contentContainer = "_b6-0";
export var editorContainer = "_b6-1";
export var quillInputForm = "_b6-2";
export var zoneDivider = "_b6-4";